import React from 'react';

const BlogSelfHelpGroup = () => (//सहाय्यता
  <div className="container py-5">
    <h2 className="mb-4 text-center text-teal fw-bold" style={{ letterSpacing: 1 }}>
      स्वयं सहाय्यता गट (Self Help Group - SHG) आणि BG Mitra
    </h2>
    <div className="row align-items-center mb-4">
      {/* <div className="col-md-5 mb-3 mb-md-0 text-center text-md-start">
        <img
          src={require('../img/identity.png')}
          alt="Self Help Group"
          style={{
            maxWidth: '100%',
            borderRadius: '16px',
            boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
            border: '2px solid #e0f2f1'
          }}
        />
      </div>
      <div className="col-md-7 text-center text-md-start">
        <iframe
          width="100%"
          height="240"
          src="https://www.youtube.com/embed/1Q8fG0TtVAY"
          title="Self Help Group Introduction"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ borderRadius: '16px', maxWidth: 400 }}
        ></iframe>
      </div> */}
    </div>
    <div className="bg-light rounded-4 p-4 mb-4 shadow-sm">
      <h4 className="mt-2 text-teal">स्वयं सहाय्यता गट म्हणजे काय?</h4>
      <p>
        स्वयं सहाय्यता गट (SHG) म्हणजे समान उद्दिष्ट असलेल्या लोकांचा एक लहान गट, जो एकत्र येऊन बचत, कर्ज, आणि आर्थिक व्यवहार पारदर्शकपणे करतो.
        हे गट विशेषतः ग्रामीण भागातील महिलांना, मजुरांना , शेतकऱ्यांना आर्थिकदृष्ट्या सक्षम बनवण्यासाठी महत्त्वाची भूमिका बजावतात.
      </p>
    </div>
    <div className="row g-4 mb-4">
      <div className="col-md-6">
        <div className="bg-white rounded-4 p-4 h-100 shadow-sm border-start border-4 border-teal">
          <h4 className="mb-3 text-teal">SHG द्वारे काय साध्य करता येईल?</h4>
          <ul className="mb-0" style={{ fontSize: '1.08em' }}>
            <li><strong>आर्थिक स्वावलंबन:</strong> सदस्यांना नियमित बचत आणि कर्ज सुविधा मिळतात.</li>
            <li><strong>समूहातील एकता:</strong> एकमेकांना मदत, मार्गदर्शन आणि सहकार्य मिळते.</li>
            <li><strong>शासनाच्या योजना:</strong> विविध सरकारी योजना आणि अनुदानांचा लाभ घेता येतो.</li>
            <li><strong>प्रशिक्षण व सक्षमीकरण:</strong> महिलांना विविध कौशल्यांचे प्रशिक्षण मिळते.</li>
            <li><strong>सामाजिक बदल:</strong> महिलांचा आत्मविश्वास वाढतो आणि समाजात सकारात्मक बदल घडतो.</li>
          </ul>
        </div>
      </div>
      <div className="col-md-6">
        <div className="bg-white rounded-4 p-4 h-100 shadow-sm border-start border-4 border-success">
          <h4 className="mb-3 text-success">BG Mitra SHG साठी कसा उपयुक्त आहे?</h4>
          <ul className="mb-0" style={{ fontSize: '1.08em' }}>
            <li><strong>डिजिटल नोंदवही:</strong> सर्व आर्थिक व्यवहार, बचत, कर्ज, दंड, व्याज इ. मोबाईलवर सहज नोंदवा.</li>
            <li><strong>पारदर्शकता:</strong> प्रत्येक व्यवहाराची माहिती सर्व सदस्यांना उपलब्ध.</li>
            <li><strong>सरल अहवाल:</strong> मासिक, वार्षिक, सदस्यनिहाय अहवाल एका क्लिकवर.</li>
            <li><strong>शासन योजना व मार्गदर्शन:</strong> सरकारी योजना, प्रशिक्षण व मार्गदर्शनाची माहिती अ‍ॅपमध्ये.</li>
            <li><strong>सुरक्षितता:</strong> डेटा सुरक्षित आणि गोपनीय ठेवला जातो.</li>
          </ul>
        </div>
      </div>
    </div>
    <div className="bg-teal text-white rounded-4 p-4 text-center shadow-sm">
      <h5 className="mb-3">तुमच्या बचत गटासाठी BachatGat Mitra बचत गट मित्र वापरून पहा!</h5>
      <p className="mb-2">
        आपल्या गटासाठी BachatGat Mitra - बचत गट मित्र वापरून डिजिटल व्यवस्थापन सुरू करा आणि गटाचा विकास साधा.
      </p>
      <p> 
        अधिक माहितीसाठी किंवा डेमो साठी <a href="https://play.google.com/store/apps/details?id=com.vlab.bgmitra" className="text-warning fw-bold text-decoration-underline">BachatGat-Mitra (बचत गट मित्र)</a> क्लीक करा .
      </p>
    </div>
  </div>
);

export default BlogSelfHelpGroup;